import { useCallback, useEffect, useState } from "react";

import styled from "styled-components/macro";

import { useBankProvider } from "Payments/globalPaymentsStateHooks";

import FnrLoadingBricks2 from "UI/FnrLoadingBricks2";
import FnrModal from "UI/FnrModal";

import useImportScript from "Utilities/useImportScript";

import API from "./API";

export default function WePayACHPlaidModal({
  show,
  setShow,
  onTokenCreation,
  onSave,
  shouldSavePaymentMethod,
  tabID,
  existingPaymentMethodID,
  additionalSettings,
  phone,
  email,
  userID,
}) {
  const positionTopIfMobile = window.innerHeight < 860;
  const [tokenID, setTokenID] = useState(null);
  const [openPlaidModal, setOpenPlaidModal] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const { provider } = useBankProvider();

  useEffect(
    function syncOpenPlaidModalWithShow() {
      setOpenPlaidModal(show);
    },
    [show]
  );

  useEffect(
    function submitData() {
      if (!tokenID) return;

      setShowSpinner(true);

      if (onTokenCreation) {
        onTokenCreation(tokenID);
      }

      let postData = {
        bankAccountToken: tokenID,
        save: shouldSavePaymentMethod,
        provider: provider,
      };

      if (tabID) postData.tabID = tabID;
      if (phone) postData.phone = phone;
      if (email) postData.email = email;
      if (userID) postData.userID = userID;
      if (existingPaymentMethodID) {
        postData.paymentMethodID = existingPaymentMethodID;
        if (additionalSettings)
          postData = { ...postData, ...additionalSettings };
      }

      const saveCall = existingPaymentMethodID
        ? API.replacePaymentMethod(postData)
        : API.createPaymentMethod(postData);

      saveCall
        .post()
        .then((resp) => {
          setTokenID(null);

          if (onSave) onSave(resp);
        })
        .catch((err) => {
          // console.log({ err });
        })
        .finally(() => {
          setShowSpinner(false);
          setShow(false);
        });

      return () => {
        saveCall.cancel();
      };
    },
    [
      tokenID,
      onSave,
      setShow,
      shouldSavePaymentMethod,
      tabID,
      onTokenCreation,
      phone,
      email,
      userID,
      existingPaymentMethodID,
      additionalSettings,
    ]
  );

  const wePayLoadedCallback = () => {
    const myAppId = window.data?.paymentPageData?.appID;
    const environment = window.data?.paymentPageData?.environment;
    const apiVersion = window.data?.paymentPageData?.apiVersion || "3.0";

    let error;
    if (environment === "api") {
      error = window.WePay?.configure("production", myAppId, apiVersion); //prod
    } else {
      error = window.WePay?.configure("stage", myAppId, apiVersion); //stage
    }

    if (error) {
      alert(
        "Hmmm... something went wrong.  Please refresh the page and try again.  If it happens again, please email help@flocknote.com.  Error:wp_config"
      );
    }
  };

  useImportScript("https://cdn.wepay.com/wepay.min.js", wePayLoadedCallback);

  const showPlaidForm = useCallback(() => {
    if (!window.WePay) {
      alert(
        "Hmmm... something went wrong.  Please refresh the page and try again.  If it happens again, please email help@flocknote.com.  Error:wp_config"
      );
      setShow(false);
      return;
    }

    const paymentBankLightBox = window.WePay.createPaymentBankLightBox(
      (data) => {
        if (paymentBankLightBox.error_code) {
          // console.log({ paymentBankLightBox });
        }
      },
      { avoid_micro_deposits: true }
    );

    const lightboxEl = document.getElementById("paymentBankLightBox");
    lightboxEl.style.zIndex = "8000";

    paymentBankLightBox
      .tokenize()
      .then((response) => {
        setTokenID(response.id);
      })
      .catch((err) => {
        if (
          err.error_code === "TOKEN_CANNOT_BE_CREATED" &&
          err.details[0].reason_code === "USER_CANCELED"
        ) {
          setShow(false);
        }
      });
  }, [setShow]);

  useEffect(
    function actuallyOpenPlaidModal() {
      if (openPlaidModal) {
        showPlaidForm();
      }
    },
    // eslint
    [openPlaidModal, showPlaidForm]
  );

  return (
    <FnrModal
      show={show}
      setShow={setShow}
      positionTopIfMobile={positionTopIfMobile}
      data-cy="wepay-ach-plaid-modal"
    >
      <Content>
        {showSpinner ? (
          <FnrLoadingBricks2 loading={true} color="white">
            <LoadingInner />
          </FnrLoadingBricks2>
        ) : null}
      </Content>
    </FnrModal>
  );
}

const Content = styled.div`
  width: min(400px, calc(100vw - 16px));
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

const LoadingInner = styled.div`
  height: 100px;
  width: 100px;
`;
